import { useState } from 'react';

import { fontStyles } from '@/styles/typography';

import { FeedbackAnimation } from './FeedbackAnimation';
import { ToastContainer, ToastContent, ToastTitle, useAutoDismiss } from './ToastComponents';

export interface PaidFeedbackToastProps {
  onClose?: () => void;
}

/**
 * Toast shown after a user successfully signs up for the paid feedback program.
 */
export function PaidFeedbackToast({ onClose }: PaidFeedbackToastProps) {
  const [isHovered, setIsHovered] = useState(false);

  useAutoDismiss(isHovered, onClose, false);

  return (
    <ToastContainer onClose={onClose} showProgressAnimation={false} onHoverChange={setIsHovered}>
      <FeedbackAnimation feedback="success" className="flex-shrink-0 relative z-10" />

      <div className="flex flex-col gap-1 min-w-0 flex-1 relative z-10">
        <ToastTitle
          className={fontStyles({
            variant: 'LABEL_MD',
            class: ['text-token-gray-1600'],
          })}
        >
          You’re signed up
        </ToastTitle>

        <ToastContent>
          <span
            className={fontStyles({
              variant: 'BODY_SM',
              class: ['text-token-gray-800'],
            })}
          >
            {`Please keep an eye out for our message.`}
          </span>
        </ToastContent>
      </div>
    </ToastContainer>
  );
}
